import { api } from 'app/utils/api/helpers'

export const getFeedStatusActivities = (teamGUID, cursor) => {
  return api.get(`/sm/teams/${teamGUID}/feedstatuslogs`, {
    params: {
      ...(cursor && { cursor: cursor }),
    },
  })
}
